import _WeakMap from '@babel/runtime-corejs3/core-js/weak-map';
import 'intersection-observer';

var observersForThreshold = {}; // eslint-disable-next-line no-spaced-func,func-call-spacing

var visibleHandlerCallbacks = new _WeakMap();

var createIntersectionObserver = function createIntersectionObserver(opt) {
  var observer = observersForThreshold[opt.threshold];

  if (!observer) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var _visibleHandlerCallba;

          (_visibleHandlerCallba = visibleHandlerCallbacks.get(entry.target)) === null || _visibleHandlerCallba === void 0 ? void 0 : _visibleHandlerCallba();
        }
      });
    }, {
      rootMargin: "".concat(opt.threshold, "px 0px"),
      threshold: [0]
    });
    observersForThreshold[opt.threshold] = observer;
  }

  return {
    observe: function observe(container, callbacks) {
      observer.observe(container);
      visibleHandlerCallbacks.set(container, callbacks.onVisible);

      var unobserve = function unobserve() {
        observer.unobserve(container);

        if (!observer.takeRecords().length) {
          delete observersForThreshold[opt.threshold];
        }

        visibleHandlerCallbacks.delete(container);
      };

      return unobserve;
    }
  };
};

export { createIntersectionObserver as default };
